import './About.css';

const TermsConditions = () => {
    return (
        <div className="about-page">
            <div className="page-hero" style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
            }}>
                <div className="container">
                    <h1>Terms & Conditions</h1>
                    <p>Please read these terms carefully before using our services</p>
                </div>
            </div>

            <div className="container section">
                <div className="content-card">
                    <p className="last-updated">Last Updated: October 15, 2025</p>

                    <section className="policy-section">
                        <h2>1. Acceptance of Terms</h2>
                        <p>By using KSA Holidays services, you agree to these terms and conditions.</p>
                    </section>

                    <section className="policy-section">
                        <h2>2. Booking and Payment</h2>
                        <ul>
                            <li>All bookings are subject to availability and confirmation</li>
                            <li>Prices are quoted in Indian Rupees (INR)</li>
                            <li>Full payment required as per agreed schedule</li>
                        </ul>
                    </section>

                    <section className="policy-section">
                        <h2>3. Travel Documents</h2>
                        <p>Passengers are responsible for valid travel documents (passport, visa). We assist with visa applications but cannot guarantee approval.</p>
                    </section>

                    <section className="policy-section">
                        <h2>4. Cancellations</h2>
                        <p>Cancellation charges apply as per our cancellation policy. Please refer to the Cancellation Policy page for details.</p>
                    </section>

                    <section className="policy-section">
                        <h2>5. Liability</h2>
                        <p>KSA Holidays acts as an agent. We are not liable for delays, accidents, or losses during travel. Travel insurance is strongly recommended.</p>
                    </section>

                    <section className="policy-section">
                        <h2>6. Contact</h2>
                        <p>For questions about these terms, please contact us through our Contact page.</p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TermsConditions;
